import { createReducer } from '@reduxjs/toolkit'; // TODO: import from `~/lib/redux` instead
import { getTeam } from '../../redux';
const initialState = {
    team: null,
    error: null,
    isLoading: false,
};
const team = createReducer(initialState, (builder) => {
    builder
        .addCase(getTeam.request, (state) => {
        state.isLoading = true;
        state.error = null;
    })
        .addCase(getTeam.success, (state, action) => {
        const { data: { team_id: id, team_name: name, boundary, center, }, } = action.payload;
        // TODO: temporary fix for invalid team data
        if (!boundary || !center) {
            state.error = 'Invalid team data';
            state.isLoading = false;
            return;
        }
        state.team = {
            id,
            name,
            boundaries: boundary,
            center: {
                type: 'Point',
                coordinates: [center.longitude, center.latitude],
            },
        };
        state.isLoading = false;
    });
});
export default team;
